import { all, fork } from "redux-saga/effects"

//public
import AuthSaga from "./auth/saga"
import ReportSaga from "./reportSaga"

export default function* rootSaga() {
  yield all([
    fork(AuthSaga),
    fork(ReportSaga)
  ])
}
